module.exports = __webpack_public_path__ + "static/media/AIF.3ad4879c.pdf";